import { AfterViewChecked, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { RedsysParams } from '@models/redsys';

@Component({
  selector: 'app-redsys-form',
  templateUrl: 'redsys-form.component.html',
  styleUrls: ['redsys-form.component.scss']
})
export class RedsysFormComponent implements AfterViewChecked {

  @ViewChild('redsysForm') el: ElementRef;
  @Input() set redsysParams(redsysParams: RedsysParams) {
    if (redsysParams) {
      this.params = redsysParams;
      this.onPost();
    }
  }

  params: RedsysParams;
  private posting = false;

  constructor() {}

  ngAfterViewChecked() {
    if (this.posting && this.el) {
      this.el.nativeElement.action = this.params.url;
      this.el.nativeElement.submit();
      this.posting = false;
    }
  }

  private onPost(): void {
    this.posting = true;
  }
}
